import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { CheckmarkOutline as IconCheckmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { DateListProps } from '../constants';

const DateList = (props: DateListProps) => {
  const { selectedItem, onClick, list } = props;
  const { t } = useTranslation();
  const { isMobile } = useScreen();

  return (
    <Box className="p-8">
      {list?.map((item) => {
        const isSelected = selectedItem?.key === item.key;

        return (
          <Box
            key={item.key}
            aria-label={t(item.label)}
            className={cn(
              'flex w-full cursor-pointer items-center justify-between rounded-8 px-12 py-10 xs:py-14 hover:bg-s-info-light',
              { 'bg-s-info-light': isSelected },
            )}
            component="button"
            role="menuitem"
            tabIndex={0}
            onClick={() => onClick(item)}>
            <Typography
              className="flex items-center"
              color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
              variant={isMobile ? 'body-short-01' : 'body-short-02'}>
              {item.Icon ? (
                <Box className="flex items-center justify-center me-12">{item.Icon}</Box>
              ) : null}
              {t(item.label)}
            </Typography>
            {isSelected ? <IconCheckmarkOutline className="h-16 w-16 text-icon-info" /> : null}
          </Box>
        );
      })}
    </Box>
  );
};

export default DateList;
